import * as paymentOrderActions from "@rentiohq/shared-frontend/dist/reduxV2/paymentOrder/paymentOrder.actions";
import * as paymentOrderSelectors from "@rentiohq/shared-frontend/dist/reduxV2/paymentOrder/paymentOrder.selectors";
import * as paymentOrderUtils from "@rentiohq/shared-frontend/dist/reduxV2/paymentOrder/paymentOrder.utils";
import { IContract } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IRootStore } from "redux/reducers";
import StatusDot from "../StatusDot";
import { EStatus } from "../StatusDot/StatusDot.types";

interface IProps {
  contract: IContract;
}

const StatusDotOutstandingContractPaymentOrders = (props: IProps) => {
  const { contract } = props;
  const { id: contractId } = contract;

  const filter = {
    and: [{ contractId: { eq: contractId } }, { completedAt: { is: null } }],
  };

  // Redux
  const dispatch = useDispatch();
  const paymentOrders = useSelector(
    (state: IRootStore) =>
      paymentOrderSelectors.getPaged(
        state,
        paymentOrderUtils.getPaymentOrdersQuery({
          filter,
        }),
      )?.items,
  );

  const isFetching = useSelector(
    (state: IRootStore) =>
      paymentOrderSelectors.getPaged(
        state,
        paymentOrderUtils.getPaymentOrdersQuery({
          filter,
        }),
      )?.isFetching,
  );

  // Lifecycle
  React.useEffect(() => {
    if (contract.manuallyCompletedEndPaymentRent) {
      return;
    }

    if (isFetching) {
      return;
    }

    // if (getStatus() === EStatus.Success) {
    //   return;
    // }

    dispatch(
      paymentOrderActions.getPagedStart.getAction({
        query: paymentOrderUtils.getPaymentOrdersQuery({
          filter,
        }),
      }),
    );
  }, [contractId]);

  // Helpers
  const getStatus = () => {
    if (contract.manuallyCompletedEndPaymentRent) {
      return EStatus.Success;
    }

    if (!paymentOrders || paymentOrders.length === 0) {
      return EStatus.Success;
    }

    return EStatus.Warning;
  };

  // Render
  const renderTooltipContent = () => {
    if (contract.manuallyCompletedEndPaymentRent) {
      return getLocalizedText(contract.manuallyCompletedEndPaymentRent);
    }

    if (!paymentOrders || paymentOrders.length === 0) {
      return getLocalizedText("status.outstanding_payments.empty");
    }

    return getLocalizedText("status.outstanding_payments.open_payments");
  };

  return (
    <StatusDot status={getStatus()} tooltipContent={renderTooltipContent()} />
  );
};

// eslint-disable-next-line import/no-default-export
export default StatusDotOutstandingContractPaymentOrders;
